import React, {useEffect, useState} from 'react';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import FinishTick from '../Assets/SVG/FinishTick';
import {prepareSameWindowUrlWithNavigateTo} from 'app/utilities/StringHelpers/StringHelpers';
import Config from 'app/Config';
import TextInput from 'app/Components/Shared/TextInput/TextInput';
import Popup from 'app/Components/Shared/Popup/PopUp';
import {validateField} from 'app/utilities/validation/formValidation';
import Stage4SVG from '../Assets/SVG/Stage4';

const NetconfigScreen = (props) => {
  const [networkName, setNetworkName] = useState('');
  const [networkNameError, setNetworkNameError] = useState(null);
  const [networkPassword, setNetworkPassword] = useState('');
  const [networkPasswordError, setNetworkPasswordError] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const checkName = () => {
    let validationRules = {
      required: true,
      requiredMessage: 'הינך מתבקש להזין שם רשת',
      regexName: 'nameAndPasswordRegex',
      regexMessage: 'שם רשת לא תקין',
    };
    let val = validateField(validationRules, networkName);
    if (val && val != '') {
      setNetworkNameError(val);
      return false;
    }
    return true;
  };

  const checkPassword = () => {
    let validationRules = {
      required: true,
      requiredMessage: 'הינך מתבקש להזין סיסמא',
      regexName: 'nameAndPasswordRegex',
      regexMessage: 'סיסמא לא תקינה',
    };
    let val = validateField(validationRules, networkPassword);
    if (val && val != '') {
      setNetworkPasswordError(val);
      return false;
    } else if (networkPassword.length < 8 || networkPassword.length > 63) {
      setNetworkPasswordError('סיסמא לא תקינה');
      return false;
    }
    return true;
  };

  const continueStep = () => {
    if (checkName() && checkPassword()) {
      props.proceedConfig(networkName, networkPassword);
    }
  };
  return (
    <>
      <div className='svgContainerHead'>
        <Stage4SVG />
      </div>
      <div className='headBox mb-24'>
        <p className='subHeading'>
          כדי שהמכשירים הקיימים יתחברו אוטומטית, <br />
          אנחנו ממליצים להישאר עם שם הרשת <br />
          והסיסמה הקודמים{' '}
        </p>
      </div>
      <div className='inputContainer'>
        <TextInput
          maxLength={32}
          required
          placeholder={'שם הרשת'}
          value={networkName}
          onChange={(e) => {
            setNetworkName(e.target.value);
            setNetworkNameError(null);
          }}
          error={networkNameError}
        />
        <p className='disclaimerText'>יש להכניס אותיות באנגלית ומספרים בלבד</p>
      </div>
      <div className='inputContainer'>
        <TextInput
          maxLength={63}
          required
          placeholder={'הזן סיסמה'}
          value={networkPassword}
          onChange={(e) => {
            setNetworkPassword(e.target.value);
            setNetworkPasswordError(null);
          }}
          error={networkPasswordError}
          type={'password'}
        />
        <p className='disclaimerText'>הסיסמה צריכה להיות באורך של 8 תווים לפחות</p>
      </div>

      <div className='fixFooter'>
        <BtnSubmit
          className='mb-12'
          text={'אפשר להתקדם'}
          onclick={() => {
            continueStep();
          }}
        />
      </div>
    </>
  );
};

export default NetconfigScreen;
